import { useFormikContext } from 'formik';
import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import CreatableSelect from 'react-select/creatable';
import { optionsStyle } from '../composables';
import { getTestRequired } from '../../../../redux/visit';
import useDebounce from '../../../../utils/useDebounceHook';

const TestRequired = () => {
	const { values, setFieldValue } = useFormikContext();
	const [testOptions, setTestOptions] = useState([]);
	const { testRequired } = useSelector(state => state.visits);
	const dispatch = useDispatch();
	const [searchTerm, setSearchTerm] = useState('');
	const debouncedSearch = useDebounce(searchTerm, 500);

	useEffect(() => {
		if (testRequired.length > 0) {
			const newOptions = testRequired.map((a) => ({ value: a.id, label: a.name, isNew: false, }));

			setTestOptions((prev) => {
				const merged = [...prev, ...newOptions];
				return merged.filter(
					(opt, index, self) => index === self.findIndex((o) => o.value === opt.value)
				);
			});
		}
	}, [testRequired]);

	useEffect(() => {
		if (debouncedSearch) {
			dispatch(getTestRequired({ search: debouncedSearch, per_page: 5, status: 'active' }));
		}
	}, [debouncedSearch, dispatch]);

	const handleChange = (selected) => {
		const mapped = (selected || []).map((opt) => {
			if (opt.__isNew__ || opt.isNew) {
				return { id: `new-${Date.now()}-${Math.random()}`, testRequiredName: opt.label };
			} else {
				return { id: `test-${opt.value}`, testRequiredId: opt.value };
			}
		});

		const newOptions = (selected || [])
			.filter((opt) => opt.__isNew__)
			.map((opt) => ({ value: opt.value, label: opt.label, isNew: true }));

		setTestOptions((prev) => {
			const merged = [...prev, ...newOptions];
			return merged.filter(
				(opt, index, self) => index === self.findIndex((o) => o.value === opt.value)
			);
		});
		setFieldValue('testRequired', mapped);
	};

	const selectedValue = (values.testRequired || []).map((item) => {

		if (item.testRequiredId) {
			return testOptions.find((opt) => opt.value === item.testRequiredId);
		}
		if (item.testRequiredName) {
			return {
				value: `new-${item.testRequiredName}`,
				label: item.testRequiredName,
				isNew: true,
			};
		}
		return null;
	}).filter(Boolean);

	return (
		<Row className="my-3">
			<Card.Title>{t('VISIT.TEST_REQUIRED')}</Card.Title>
			<Col md={12}>
				<CreatableSelect
					isMulti
					menuPortalTarget={document.body}
					styles={optionsStyle}
					isClearable
					options={testOptions}
					value={selectedValue}
					onChange={handleChange}
					onInputChange={(inputValue, { action }) => {
						if (action === 'input-change') {
							setSearchTerm(inputValue);
						}
					}}
					isValidNewOption={(inputValue, _selectValue, selectOptions) =>
						!!inputValue.trim() &&
						!selectOptions.some(
							(opt) => opt.label.toLowerCase() === inputValue.trim().toLowerCase()
						)
					}
					filterOption={(option, rawInput) =>
						!selectedValue.some((sel) => sel.label.toLowerCase() === option.label.toLowerCase()) &&
						option.label.toLowerCase().includes(rawInput.toLowerCase())
					}
				/>
			</Col>
		</Row>
	);
};
export default TestRequired;
